import { Directive, HostListener, Input } from '@angular/core';
import { FileItem } from '../models';
import { LinkCopyService } from '../services/link-copy.service';

@Directive({
  selector: '[appCopyLink]'
})
export class CopyLinkDirective {

  @Input('appCopyLink') rowData: FileItem;

  constructor(
    private linkCopyService: LinkCopyService
  ) { }

  @HostListener('click', ['$event'])
  async onClick(event: MouseEvent) {
    event.stopPropagation();
    await this.linkCopyService.copyLink(this.rowData);
  }

}
